import { SanityPersonContacts } from '../../types/generated/graphql-types'
import { MarketContactPersonsSectionProps } from '../components/blocks/market/MarketContactPersonsSection'
import { Breakpoints, resolveBreakpointName } from '../utilities/breakpoints'
import { notEmpty } from '../utilities/filters'
import { imagePresetUrl, Presets } from '../utilities/imagePreset'

export const mapSanityPersonContactsToMarketContactPersonsSection = ({
  persons,
  title,
}: SanityPersonContacts): MarketContactPersonsSectionProps => ({
  contacts: persons?.filter(notEmpty).map(person => ({
    email: person.email ?? undefined,
    imageProps: person.portrait
      ? {
          altText: person.portrait.altText ?? person.title ?? '',
          src:
            imagePresetUrl(
              person.portrait,
              Presets.marketContactPersonsSectionImage.small
            ) ?? '',
          sources: [
            {
              srcSet:
                imagePresetUrl(
                  person.portrait,
                  Presets.marketContactPersonsSectionImage.large
                ) ?? '',
              minimumBreakpoint: resolveBreakpointName(Breakpoints.xxl),
            },
          ],
        }
      : undefined,
    name: person.title ?? undefined,
    phoneNumber: person.phoneNumber ?? undefined,
    workTitle: person.workTitle ?? undefined,
  })),
  title: title ?? undefined,
})
